angular.module('lf.common')

.directive('historyBackButton', function () {
  return {
    restrict: 'A',
    link: function (scope, el, attrs) {
      el.on('click', function (e) {
        e.preventDefault();
        window.history.go(attrs.historyBackButton ? parseInt(attrs.historyBackButton) : -1);
      });
    }
  }
});
